<template>
  <div
    class="w-full"
    :class="
      type === 'fluid'
        ? '-mx-[100px] flex flex-col items-center'
        : 'px-4 md:px-6'
    "
  >
    <div
      class="relative w-full max-w-8xl"
      :class="{
        'mx-auto max-w-8xl': content === 'default',
        'px-4 md:px-6': type === 'fluid',
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  type: {
    type: [String],
    default: 'default',
  },
  content: {
    type: [String],
    default: 'default',
  },
})
</script>
